module.exports = __webpack_public_path__ + "static/media/programLogo.5571e7b8.svg";